import {course_getCourseClassById_Api,} from 'apis'
import useAsyncAction from 'modules/asyncCache/useAsyncAction'
import React, {useContext, useEffect, useState,} from 'react'
import {useRouteSearchParam} from "../../../../envs/_current/history";
import {CourseContainerContext} from "./CourseContainer";
import {BsArrowLeftCircle, BsCalendar2Week, BsGearFill} from "react-icons/bs";
import _ from "lodash"
import useTranslate from "../../../../modules/local/useTranslate";
import {PiTextSuperscriptBold} from "react-icons/pi";
import {bindingSearch} from "../../../Shared/components/PagerControls";
import {CourseClassSubjectList} from "../../../AppLocals/Course/CourseClass/components/CourseClassSubjectForm";
import {useCourseClassForm} from "../../../AppLocals/Course/CourseClass/useCourseClassForm";
import {CourseClassStudentList} from "../../../AppLocals/Course/CourseClass/CourseClassStudentForm";
import CourseClassTeachers from "../../../AppLocals/Course/CourseClass/CourseClassTeachers";
import {CourseClassTimetables} from "../../../AppLocals/Course/CourseClass/CourseClassTimetableForm";
import {EditCourseClassModal} from "../../../AppLocals/Course/CourseClass/CourseClassForm";
import {NullAsDefault} from "../../../Shared";
import {useCourseClassApi} from "../../../AppLocals/Course/CourseClass/useCourseClassApi";
import {ClassActionTypes, TimetableActionTypes} from "../../../AppLocals/Course";
import useCourseClassTimetable from "../../../AppLocals/Course/CourseClass/useCourseClassTimetable";
import {useRouterSearchParam} from "../../../../modules/navigation/useOnLocationChange";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../../../helpers/getLinkToDetail";
import {FaUserGraduate, FaUserTie} from "react-icons/fa6";
import classNames from "classnames";
import {Button} from "antd";
import getTitle from "../../../../helpers/getTitle";
import {DoubleValueItem} from "../../../AppLocals/CatholicHousehold/components/CatholicHouseholdComponents";
import {formatSimplifyDate} from "../../../../helpers/dateUtils";
import {ItemInformation} from "../../../AppLocals/Organization/OrganizationEntity";
import {AiFillDelete} from "react-icons/ai";

const CLASS_TABS = [
    {key: 'schedule', name: 'schedule', icon: <BsCalendar2Week size={18}/>, content: 'schedule content calendar view'},
    // {key: 'attendance', name: 'Điểm danh', icon: PiChecks, content: 'Nội dung Điểm danh từng buổi.'},
    // {key: 'grading', name: 'Đánh giá & Điểm', icon: PiGraduationCap, content: 'Nội dung Sổ điểm (Gradebook).'},
    {
        key: 'subject',
        name: 'subject',
        icon: <PiTextSuperscriptBold size={18}/>,
        content: 'subject structure and materials content'
    },
    {
        key: 'student',
        name: 'student',
        icon: <FaUserGraduate size={15}/>,
        content: 'students currently in the class',
    },
    {
        key: 'teacher',
        name: 'teacher',
        icon: <FaUserTie size={15}/>,
        content: 'instructors currently in the class'
    },
    {
        key: 'settings',
        name: 'class settings',
        icon: <BsGearFill size={16}/>,
        content: 'class settings content date badge'
    },
    {
        key: 'destroy',
        name: 'delete content',
        icon: <AiFillDelete size={16}/>,
        content: 'class settings content date badge'
    },
];


// --- Component Tab điều hướng (Dùng chung cho Cấp 2 & Cấp 3) ---
const TabNavigation = ({tabs, activeTab, onTabChange}) => {
    const t = useTranslate();

    return (
        <div
            style={{top: 'calc(3.5 * var(--header-height))', zIndex: 12}}
            className="mt-6 flex gap-1 overflow-x-auto background-100 rounded-t-xl border-b border-color-300 sticky">
            {tabs.map((tab) => (
                <button
                    key={tab.key}
                    onClick={() => onTabChange(tab.key)}
                    className={classNames(
                        `p-3 flex flex-center flex-shrink-0 gap-2 text-sm font-medium transition-colors border-b-2`,
                        activeTab === tab.key
                            ? 'border-indigo-500 text-indigo-600'
                            : 'border-transparent text-color-200 hover:text-indigo-500 hover:border-indigo-300'
                    )}>
                    {tab?.icon}
                    <span className="hidden lg:block">{t(tab.name)}</span>
                    <span className="lg:hidden">{t(tab.name)}</span>
                </button>
            ))}
        </div>
    );

}

const CourseClassDetail = ({}) => {
    const t = useTranslate();
    const courseClassDetailTab = useRouteSearchParam("course-class-detail-tab") || "schedule"
    const [activeTab, setActiveTab] = useState(courseClassDetailTab);
    const [selectedCourseClass, setSelectedCourseClass] = useState({});
    const {
        current_course_id, setCurrentCourseId,
        current_course_class_id, setCurrentCourseClassId,
        onSelectCourseContainerRoute
    } = useContext(CourseContainerContext);

    const {handleAsyncAction: getCourseClassById} = useAsyncAction({
        apiInfo: course_getCourseClassById_Api,
        onSuccess: (result, data) => {
            const dataItem = _.get(data, 'response.data');
            setSelectedCourseClass(dataItem);
        },
    })
    const {onChangeSearchParams} = useRouterSearchParam({})

    const course = _.get(selectedCourseClass, 'course', {});
    const {
        modal: courseClassModal,
        handleAction: handleCourseClassAction,
        onCancel: onCourseClassCancel,
        refreshKey: refreshCourseClassKey
    } = useCourseClassForm({course})
    const {
        onUpdate: onCourseClassUpdate
    } = useCourseClassApi({
        onUpdated: NullAsDefault,
    })

    const {
        modal: courseClassTimetableModal,
        handleAction: handleCourseClassTimetableAction,
    } = useCourseClassTimetable({item: selectedCourseClass})

    useEffect(() => {
        if (current_course_class_id) {
            getCourseClassById({}, {id: current_course_class_id})
        }
    }, [current_course_class_id])

    const renderCourseClassContent = () => {
        switch (activeTab) {
            case 'schedule':
                return (
                    <div className="flex flex-col">
                        <h3 className="mb-4 font-bold text-base text-gray-700 tracking-wide uppercase">
                            {t("learning schedule")}
                        </h3>
                        <div className="p-3 border border-color-50 shadow-md rounded-lg flex flex-col gap-3">
                            <span className="text-color-300 tracking-wider">
                                {t('display the class timetable in calendar view each session is linked to a subject')}
                            </span>
                            <div className="flex justify-end">
                                <Button
                                    color="primary" variant="solid"
                                    className="flex flex-center no-border font-semibold"
                                    onClick={() => {
                                        handleCourseClassTimetableAction(TimetableActionTypes.TIMETABLE_CREATE)
                                    }}>
                                    {t('add session')}
                                </Button>
                            </div>
                        </div>
                        {
                            !!selectedCourseClass?.id && bindingSearch({
                                onCancel: onCourseClassCancel,
                                owner_id: selectedCourseClass?.owner?.id,
                                owner_type: selectedCourseClass?.owner?._type,
                                item: selectedCourseClass,
                            })(CourseClassTimetables)
                        }
                    </div>
                );
            case 'attendance':
                return (
                    <div className="flex flex-col">
                        <h3 className="mb-4 font-bold text-base text-gray-700 tracking-wide uppercase">
                            {t("attendance")}
                        </h3>
                        <p className="text-gray-600">{t("manage student attendance status in this class")}<span
                            className="font-bold text-red-500">{`${t('action')}: ${t("manual attendance qr code")}`}</span>
                        </p>
                        <div className="mt-4 p-4 bg-yellow-50 border border-yellow-200 rounded-lg">
                            {t("attendance table description")}
                        </div>
                    </div>
                );
            case 'grading':
                return (
                    <div className="flex flex-col space-y-6">
                        <h3 className="mb-4 font-bold text-base text-gray-700 tracking-wide uppercase">
                            {t("gradebook and evaluation")}
                        </h3>
                        <p className="text-color-300 tracking-wider">
                            {t("gradebook description")}
                            <span className="font-bold text-red-500">
                                {t("action enter update grades")}
                            </span>
                        </p>
                        <div className="mt-4 p-4 bg-green-50 border border-green-200 rounded-lg">
                            {t("gradebook view description")}
                        </div>
                    </div>
                );
            case 'subject':
                return (
                    <div className="flex flex-col">
                        <h3 className="mb-4 font-bold text-base text-gray-700 tracking-wide uppercase">
                            {t("subjects")}
                            ({_.get(selectedCourseClass, 'class_subjects', []).length})
                        </h3>
                        <div className="flex flex-col gap-4">
                            {
                                !!selectedCourseClass?.id && bindingSearch({
                                    onCancel: onCourseClassCancel,
                                    item: selectedCourseClass,
                                })(CourseClassSubjectList)
                            }
                        </div>
                    </div>
                );
            case 'student':
                return (
                    <div className="flex flex-col">
                        {/*<h3 className="mb-4 font-bold text-base text-gray-700 tracking-wide uppercase">*/}
                        {/*    {t("students")}*/}
                        {/*</h3>*/}

                        <div className="flex flex-col gap-4">
                            {
                                !!selectedCourseClass?.id && bindingSearch({
                                    onCancel: onCourseClassCancel,
                                    owner_id: selectedCourseClass?.owner?.id,
                                    owner_type: selectedCourseClass?.owner?._type,
                                    item: selectedCourseClass,
                                })(CourseClassStudentList)
                            }
                        </div>
                    </div>
                );
            case 'teacher':
                return (
                    <div className="flex flex-col">
                        {/*<h3 className="mb-4 font-bold text-base text-gray-700 tracking-wide uppercase">*/}
                        {/*    {t("teachers")}*/}
                        {/*</h3>*/}

                        <div className="flex flex-col gap-4">
                            {
                                !!selectedCourseClass?.id && bindingSearch({
                                    onCancel: onCourseClassCancel,
                                    owner_id: selectedCourseClass?.owner?.id,
                                    owner_type: selectedCourseClass?.owner?._type,
                                    item: selectedCourseClass,
                                })(CourseClassTeachers)
                            }
                        </div>
                    </div>
                );
            case 'settings':
                return (
                    <div className="flex flex-col">
                        <h3 className="mb-2 font-bold text-base text-gray-700 tracking-wide uppercase">
                            {t("class settings")}
                        </h3>
                        <div className="mb-4 text-color-300 tracking-wider">
                            {t("manage name description start end dates")}
                        </div>
                        <div className="my-3 flex flex-col gap-1">
                            <label className="text-sm font-medium text-color-200 tracking-wider">
                                {t('belong to the course')}
                            </label>
                            <div className="p-3 flex flex-col border border-color-50 shadow rounded-lg">
                                <div className="mb-2 pb-2 border-b border-color-100 flex items-center gap-2">
                                    <span className="font-bold text-base text-color-000 tracking-wide">
                                        {getTitle(course)}
                                    </span>
                                </div>
                                <div className="flex flex-col flex-1 gap-1">
                                    {(course?.academic_field !== null || course?.academic_year !== 0) && (
                                        <div
                                            style={{ padding: '3px 8px', fontSize: 11, borderRadius: 999, wordBreak: 'break-all' }}
                                            className="w-fit border border-primary-400 font-medium text-primary-700 italic leading-tight min-w-0 max-lines-1">
                                            {course?.academic_field}
                                            {(course?.academic_year !== 0 && course?.academic_field !== null) ? ` - ${course?.academic_year}` : course?.academic_year !== 0 ? course?.academic_year : ''}
                                        </div>
                                    )}
                                    {_.some([course?.time_open, course?.time_close]) && (
                                        <DoubleValueItem
                                            showIcon={true}
                                            labelFirst="time"
                                            valueFirst={formatSimplifyDate(course?.time_open, 'medium')}
                                            labelSecond={course?.time_close && ' - ' || ''}
                                            valueSecond={course?.time_close && formatSimplifyDate(course?.time_close, 'medium')}
                                            className="text-xs italic"
                                        />
                                    )}
                                    {course?.last_enrollment_time && (
                                        <ItemInformation
                                            showIcon={true}
                                            label="last enrollment time"
                                            value={formatSimplifyDate(course?.last_enrollment_time, 'medium')}
                                            className="text-xs italic tracking-wide"
                                        />
                                    )}
                                </div>
                            </div>
                        </div>

                        {
                            !!selectedCourseClass?.id && (
                                <EditCourseClassModal
                                    item={selectedCourseClass}
                                    owner_id={course?.owner?.id}
                                    owner_type={course?.owner?._type}
                                    container={course}
                                    initialValues={selectedCourseClass}
                                    onCancel={onCourseClassCancel}
                                    onSubmit={(values) => {
                                        onCourseClassUpdate(values, {id: selectedCourseClass?.id})
                                    }}
                                />
                            )
                        }

                    </div>
                );
            case 'destroy':
                return (
                    <div className="flex flex-col">

                        <div className="bg-white p-4 rounded-xl shadow-lg border-l-4 border-red-500">
                            <h3 className="mb-2 font-bold text-base text-gray-700 tracking-wide uppercase">
                                {t("delete class")}
                            </h3>
                            <div className="mb-4 text-color-300 tracking-wider">
                                {t("this action will permanently delete the class and all related data please confirm before proceeding")}
                            </div>
                            <div className="flex justify-end">
                                <button
                                    onClick={() => {
                                        handleCourseClassAction(ClassActionTypes.CLASS_DELETE, selectedCourseClass)
                                    }}
                                    className="px-6 py-2 bg-red-600 hover:bg-red-700 shadow-md rounded-lg font-medium text-white"
                                >
                                    {t("delete class permanently")}
                                </button>
                            </div>
                        </div>
                    </div>
                );
            default:
                return null;
        }
    };

    return (
        <div className="w-full min-h-screen">
            <div className="mb-6 p-4 background shadow-lg rounded-b-xl stickyTop1 z-12">
                <button
                    onClick={() => {
                        onSelectCourseContainerRoute({current_course_class_id: ''})
                    }}
                    className="mb-2 flex items-center text-color-300 hover:text-color-100 tracking-wide cursor-pointer">
                    <BsArrowLeftCircle size={18} className="mr-2"/>
                    {`${t("back to course")} :`}
                    <span className="ml-1 font-medium text-primary-800 italic">
                        {course.title}
                    </span>
                </button>
                <Link to={getLinkToDetail(selectedCourseClass)} className="text-gray-800 no-underline">
                    <h1 className="text-2xl font-bold space-x-1">
                        <span className="underline">{t("course_class")}:</span>
                        <span>{selectedCourseClass.title}</span>
                    </h1>
                </Link>
                <p className="text-sm text-color-300 tracking-wider italic">
                    {`${t("teacher")} :`}
                    <span className="ml-1 font-semibold text-color-100">
                        {_.get(selectedCourseClass, 'coordinators.0.teacher.fullname')}
                    </span>
                    {' | '}
                    <span className="mr-1 font-semibold text-color-100">
                        {selectedCourseClass.student_count}
                    </span>
                    {t("students")}
                </p>
            </div>

            <TabNavigation tabs={CLASS_TABS} activeTab={activeTab} onTabChange={(value) => {
                onChangeSearchParams({"course-class-detail-tab": value})
                setActiveTab(value)
            }}/>

            {/* Nội dung Tab */}
            <div className="p-6 background rounded-b-xl shadow-lg">
                {renderCourseClassContent()}
            </div>

            {courseClassModal}
            {courseClassTimetableModal}
        </div>
    );
};


export default CourseClassDetail
